<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/admission-desktop-banners/Scholarship-1.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/admission-desktop-banners/medium-screen/Scholarship-2.webp">
        <img
            src="assets/img/admissions-mobile-banners/Scholarship-2.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>

        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white aarni-font text-justify">
            <h2 class="text-2xl font-bold mb-4">Payment Procedure</h2>
            <p class="my-2">ARNI University offers multiple options for efficient, hassle-free, and secure fee payment
                for its students. Various modes of fee payment for Indian students are provided below.</p>
            <p class="font-bold my-4 text-lg">Online Fee Payment For National Students:</p>
            <p class="mb-2">ARNI University students can make online payments for all fees related to Registration,
                Academics, Hostel, and other applicable charges.</p>
            <p class="font-semibold">1. Payment via NEFT/RTGS/IMPS mode Only, Please transfer the amount as per below
                details:</p>
            <div class="overflow-x-auto">
                <table class="min-w-lg table-auto border border-gray-300">
                    <thead>
                    <tr class="flex justify-center">
                        <th class=" px-4 py-2 ">
                            <img src="assets/img/bank-logos/kotak-bank.png" alt="KOTAK" class="h-16 w-auto"/>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="text-center">
                        <td class="border px-4 py-2">
                            <p>Account Name- <span class="font-semibold">ARNI Educational Trust</span></p>
                        </td>
                    </tr>
                    <tr class="text-center">
                        <td class="border px-4 py-2">
                            <p>Account Number- <span class="font-semibold">ARNI +</span></p>
                            <p><span class="font-semibold">Your System ID,</span> for E.g. ARNI2024xxxxxx</p>
                        </td>
                    </tr>
                    <tr class="text-center">
                        <td class="border px-4 py-2">
                            <p>Bank Name- <span class="font-semibold"> Kotak Mahindra Bank Ltd.</span></p>
                        </td>
                    </tr>
                    <tr class="text-center">
                        <td class="border px-4 py-2">
                            <p>IFSC Code- <span class="font-semibold"> KKBK0005028</span></p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p class="mb-4 font-semibold text-xl text-green-600 my-4">Please do not Pay through Phone Pay / Google Pay &
                UPI</p>
            <p class="mb-2 font-semibold">Note: Please do not transfer the payment through RTGS/NEFT/IMPS apart from
                above bank
                details. If the payment is made it will be at your risk. University will not entertained such
                payment.</p>
            <p class="font-semibold">2. Through Students login:</p>
            <p class="my-2">(Students/ Parents can log-in to Student Portal for the Online Payment of fee and
                conveniently pay
                through following payment gateways)</p>
            <a href="https://admin.arni.in/student" target="_blank"
               class="text-[#00c1a1]">https://admin.arni.in/student</a>
            <p class="font-semibold">3. Students can now pay FEES in Easy Monthly Installments and get multiple rewards
                through GrayQuest India's leading fee payment platform.</p>
            <div class="flex w-full my-4 gap-4">
                <div class="w-1/2">
                    <img src="assets/img/grayquest.png" alt="Grayquest" class="w-full h-auto object-cover">
                </div>
            </div>
            <ul class="list-disc pl-6 my-4">
                <li><strong>Apply Online:</strong> Visit the GrayQuest website or the specific link provided by your
                    educational institution to initiate the application process.
                </li>
                <li><strong>Login:</strong> Use your student ID or registered phone number to log in.</li>
                <li><strong>Enter Fee Details:</strong> Input the outstanding fee amount as per your institution's fee
                    structure.
                </li>
                <li><strong>Select EMI Plan:</strong> Choose from the available EMI options that suit your financial
                    preferences.
                </li>
                <li><strong>Fill Application:</strong> Provide the necessary personal and academic details in the
                    application form.
                </li>
                <li><strong>Submit KYC Documents:</strong> Upload required KYC documents, such as a self-attested copy
                    of your PAN Card and one address proof (Aadhar, Driving License, Passport, or Voter ID).
                </li>
                <li><strong>Review and Submit:</strong> Ensure all details are correct and submit the application.</li>
                <li><strong>Digital Agreement:</strong> Sign the digital agreement to formalize the EMI plan.</li>
                <li><strong>Fee Disbursement:</strong> Upon approval, GrayQuest disburses the fee directly to your
                    educational institution.
                </li>
                <li><strong>Monthly Repayments:</strong> Repay the loan in equal monthly installments through auto-debit
                    from your bank account or via online payment methods like Netbanking, UPI, or Debit Cards.
                </li>
            </ul>

            <p class="font-bold my-4 text-lg">Other Fee Payment Option</p>
            <ol class="list-decimal pl-6 space-y-2 mb-4">
                <li>
                    Debit/Credit card swipe at the cash counter (additional charges may apply as per banking norms).
                    Cash counters are located at the ARNI University campus in the Finance & Accounts section.
                </li>
                <li>
                    Cash or Demand Draft deposit at the cash counter.
                </li>
                <li>
                    Cheques will be accepted from first-year students only.
                </li>
            </ol>
            <p>Please draw the Demand draft in favour of "ARNI University". Please mention your name, System Id and
                contact number on the backside.</p>
            <p class="my-2">Helpdesk for Student, Staff and vendors relating to accounts related issue:</p>
            <p class="mb-2"><span class="font-semibold">Email ID:</span> finance@arni.in</p>
            <p class="mb-2">
                <span class="font-semibold">Help Desk Phone No / WhatsApp No:</span>
                <a href="https://wa.me/917876500601" target="_blank" rel="noopener noreferrer"
                   class="text-green-600">
                     +91-7876500601
                </a>
            </p>
            <p class="mt-2 mb-4">Announcement:</p>
            <ul class="list-disc pl-6 space-y-2 mb-2">
                <li>
                    Students are advised to deposit the fee to the ARNI University account only as per the details
                    published above. The University will not be liable if the payment is made to any other account.
                </li>
                <li>
                    The receipt for online fee payment can be downloaded from the student login dashboard after 48 hours
                    of successful payment, or it can be collected from the Fee Counter at ARNI University.
                </li>
                <li>
                    Fee payment in cash exceeding INR 50,000 is not acceptable under any circumstances in a single
                    academic session.
                </li>
            </ul>
            <p class="mb-4 font-semibold text-lg md:text-xl text-green-600">Online Fee Payment For International
                Students</p>
        </section>
    </div>

</div>
